// extracted by mini-css-extract-plugin
export default {"fundDisplay":"group-gift-redemption-modal__fundDisplay__ItGb2","fund":"group-gift-redemption-modal__fund___wKEr"};